import { ArrowUpRight } from 'lucide-react';
import { GoogleMapsIcon } from '@/components/map/GoogleMapsIcon';
import { getGoogleMapsUrl } from '@/components/map/googleMaps';
import { buttonVariants } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface OpenInGoogleMapsButtonProps {
  latitude: number | null;
  longitude: number | null;
}

export function OpenInGoogleMapsButton({ latitude, longitude }: OpenInGoogleMapsButtonProps) {
  if (latitude === null || longitude === null) return null;

  return (
    <a
      href={getGoogleMapsUrl(latitude, longitude)}
      target="_blank"
      rel="noreferrer"
      className={cn(buttonVariants({ size: 'lg' }), 'w-full')}
    >
      <span className="flex size-6 items-center justify-center rounded-full bg-background">
        <GoogleMapsIcon className="size-3.5" />
      </span>
      Open in Google Maps
      <ArrowUpRight className="text-primary-foreground/80" aria-hidden />
    </a>
  );
}
